import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { getLocalisationDataFromStorage } from '@src/utils/general.utils'

import isBrowser from '../../../utils/isBrowser'
import { ZIP_COOKIE_KEY } from '../context/zipcode.context.provider'

export function validateZipCode(zipcode?: string) {
  if (!zipcode) {
    return false
  }
  const localizationData = getLocalisationDataFromStorage()

  const usRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  const canadianRegex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/

  if (!localizationData || localizationData?.country === 'US') {
    if (usRegex.test(zipcode)) {
      return true
    }
  }

  if (localizationData?.country === 'CA') {
    if (canadianRegex.test(zipcode)) {
      return true
    }
  }

  return false
}

export function getZipCodeFromCookie() {
  return getCookie(ZIP_COOKIE_KEY)
}

export function getZipCodeModalInitialState() {
  if (isBrowser()) {
    const hash = window.location.hash
    return hash === '#get-zip-code'
  }
  return false
}
